import React from 'react';

const LiveTimer = ({total=10000, stopPoint=10000, remaining=10000, onComplete, className=''}) => {

	// if timer total is less than (or equal to) zero, don't render it
	if (total <= 0) return null;

	const stopPercent = Math.round(Math.min(1, Math.max(0, stopPoint / total)) * 100);
	const fullPercent = Math.round(Math.min(1, Math.max(0, remaining / total)) * 100);

	return (
		<div className={`w-full bg-white bg-opacity-40 rounded-full h-7 relative p-2.5 ${className}`}>
			<div className={'relative w-full bg-white bg-opacity-30 rounded-full h-2'}>
          <div
            style={{
              '--stopPercent': `${stopPercent}%`
            }}
            className={'absolute w-[--stopPercent] bg-primary rounded-full h-2 bg-opacity-50'}
          />
          <div
            style={{
              '--fullPercent': `${fullPercent}%`
            }}
            className={'absolute w-[--fullPercent] bg-primary rounded-full h-2 bg-opacity-50'}
          />
      </div>
		</div>
	);
};

export default LiveTimer;
